import { useInfiniteQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const useGetSearchedTables = ({
  tableNameKeyword,
  config,
  pageNumber = 1,
}) => {
  const { addNotification } = useNotificationStore();

  const queryKey = ['searchedTablesWithTableName', tableNameKeyword];

  return useInfiniteQuery(
    queryKey,
    ({ pageParam = pageNumber }) =>
      axios.get(
        `/api/v1/integration/data-dictionaries/tables?tableNameKeyword=${tableNameKeyword}&pageSize=100&pageNumber=${pageParam}`
      ),
    {
      ...config,
      getNextPageParam: (lastPage, allPages) => {
        return lastPage.pageNumber < lastPage.totalPages
          ? lastPage.pageNumber + 1
          : undefined;
      },
      onError: (error) => {
        addNotification({
          type: 'error',
          title: error.message,
        });
      },
    }
  );
};
